
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"42.148","height":"42.129"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Groupe 1458","transform":"translate(-16814 4208)"}},[_c('rect',{attrs:{"data-name":"Rectangle 60","width":"42.148","height":"42.129","rx":"5","transform":"translate(16814 -4208)","fill":"#e5ecf0"}}),_c('g',{attrs:{"data-name":"noun_touch down_2684470"}},[_c('path',{attrs:{"data-name":"Tracé 6751","d":"M16838.285-4187.837a.748.748 0 011.061 1.056l-3.74 3.74a.748.748 0 01-1.058 0l-3.74-3.74a.748.748 0 011.055-1.056l2.463 2.463v-9.415a.75.75 0 111.5 0v9.414zm-10.691 9.5a.75.75 0 110-1.5h14.959a.75.75 0 110 1.5z","fill":"#044370"}})])])])
          )
        }
      }
    